import {
    useCategoriesStore,
    useFacetsStore,
    useRegionsStore,
    useLocationsStore,
    useQueryParamsStore,
    useDatesStore,
} from '@timezoneone/dottie-client-jam';

export function useClearFilters() {
    const regionsStore = useRegionsStore();
    const locationsStore = useLocationsStore();
    const categoriesStore = useCategoriesStore();
    const facetsStore = useFacetsStore();
    const queryParamsStore = useQueryParamsStore();
    const datesStore = useDatesStore();

    categoriesStore.setChosenTopLevelCategory('');
    categoriesStore.uncheckAllCategories();
    regionsStore.setChosenRegion('');
    locationsStore.updateSelectedLocations([]);
    facetsStore.uncheckAllFacets();
    datesStore.updateDate('startDate', '');
    datesStore.updateDate('endDate', '');

    queryParamsStore.resetParamArray('facets');
    queryParamsStore.resetParamArray('places');

    queryParamsStore.updateParamString('bounds', null);
    queryParamsStore.updateParamString('startDate', null);
    queryParamsStore.updateParamString('endDate', null);
    queryParamsStore.updateParamString('keywords', null);

}
